import { Duration } from 'luxon';
import React, { useEffect, useRef, useState } from 'react';
import * as styles from '../styles/timeElapsed.module.scss';

const getSecondsElapsed = (start?: number) => {
  const now = Date.now();
  return start ? Math.floor((now - start) / 1000) : 0;
};

const formatTime = (secondsElapsed: number) => {
  return Duration.fromObject({ seconds: secondsElapsed }).toFormat('hh:mm:ss');
};

interface Props {
  start?: number;
  autoUpdate?: boolean;
}

const TimeElapsed: React.FC<Props> = ({ start, autoUpdate }) => {
  const [secondsElapsed, setSecondsElapsed] = useState(
    getSecondsElapsed(start),
  );
  const interval = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (autoUpdate) {
      interval.current = setInterval(() => {
        const elapsed = getSecondsElapsed(start);
        setSecondsElapsed(elapsed);
      }, 100);
    }

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [autoUpdate, start]);

  return <time className={styles.time}>{formatTime(secondsElapsed)}</time>;
};

export default TimeElapsed;
